import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

export type SkeletonShape = 'text' | 'block' | 'circle';

/**
 * Single placeholder shape with a shimmer. Decorative only — the surrounding skeleton group
 * (ctv-skeleton-table / ctv-skeleton-card / page-loader) carries the status role + label.
 */
@Component({
    selector: 'ctv-skeleton',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SkeletonComponent {
  @Input() public shape: SkeletonShape = 'text';
  /** Any CSS length. Defaults: text/block = 100%, circle = 40px. */
  @Input() public width: string | null = null;
  /** Any CSS length. Defaults come from the shape's class. */
  @Input() public height: string | null = null;

  @HostBinding('class') public get hostClass(): string {
    return `dxk-skeleton dxk-skeleton--${this.shape}`;
  }
  @HostBinding('attr.aria-hidden') public readonly ariaHidden = 'true';
  @HostBinding('style.width') public get hostWidth(): string {
    return this.width ?? (this.shape === 'circle' ? '40px' : '100%');
  }
  @HostBinding('style.height') public get hostHeight(): string | null {
    return this.height ?? (this.shape === 'circle' ? (this.width ?? '40px') : null);
  }
}
